import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.8707 4.637L12.8657 4.63217L13.7193 3.80675C14.1087 3.43024 14.1087 2.82203 13.7193 2.44552L13.5496 2.2814C13.1603 1.9049 12.5313 1.9049 12.1419 2.2814L11.2884 3.10683L11.2834 3.102C10.894 2.72549 10.2651 2.72549 9.87571 3.102L3.74593 9.0296C3.64609 9.12614 3.56623 9.24198 3.51631 9.36749L2.02879 13.1712C1.88019 13.5592 2.1805 14.0014 2.59784 14.0014H11.0837C11.3632 14.0014 11.5829 13.789 11.5829 13.5187C11.5829 13.2484 11.3632 13.036 11.0837 13.036H3.96282L6.39152 12.1479C6.5213 12.0996 6.6411 12.0224 6.74094 11.9258L12.8707 5.99822C13.2601 5.62171 13.2601 5.01351 12.8707 4.637ZM4.44108 9.74846L10.5707 3.82101C10.5707 3.82101 10.5751 3.81962 10.5795 3.81962C10.584 3.81962 10.5884 3.82101 10.5884 3.82101L12.136 5.31761L6.04578 11.207C6.04367 11.209 6.04002 11.2116 6.04002 11.2116L3.50654 12.1381L4.44108 9.74846Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }